import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputAdornment, TextField } from '@mui/material';
import whatsappIcon from "../assets/images/whatsapp-icon.svg";
import { toast } from 'react-toastify';
import axios from 'axios';
import Swal from "sweetalert2";

const Register = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [errorText, setErrorText] = useState(false);
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState({ phone: false, email: false, fullName: false });
  const navigate = useNavigate();
  useEffect(()=> {
    localStorage.setItem('user-email', email)
  }, [email])
  const sendFirstStepData = () => {
    setErrorText(false)
    axios.post(`${process.env.REACT_APP_BE_BASE_URL}user/register?step=1`,
      {
        full_name: fullName,
        email: email,
        phone_number: process.env.REACT_APP_COUNTRY_CODE === "+972" ? `+972${phoneNumber.replace(/^\+972/, "").replace(/^0/, "").replaceAll("-", "").trim()}` :  `+91${phoneNumber.replace(/^\+91/, "").replace(/^0/, "").replaceAll("-", "").trim()}`,
      }
    ).then((res) => {
      toast.success(`OTP sent to ${phoneNumber} successfully!`);
      navigate('/otp?from=register', { state: { phoneNumber, email, fullName } });
    }).catch((err) => {
      if (err && err.status === 409) {
        Swal.fire({
          title: "האימייל או הטלפון כבר קיימים?",
          text: "האימייל שהוזן כבר קיים, אנא התחבר או הירשם עם פרטים אחרים!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "התחברות",
          confirmButtonColor: '#1B7870',
          cancelButtonText: "להישאר בהרשמה",
          cancelButtonColor: 'f6f6f6',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/login')
          }
        });
      } else {
        toast.error(`Unable to send OTP to ${phoneNumber}, please check the data correctly!`);
      }
      setErrorText(true)
      console.error('Error sending data', err);
    });
  };

  const validateForm = () => {
    const newError = {
      phone: !phoneNumber.trim(),
      email: !email.trim() || !/\S+@\S+\.\S+/.test(email),
      fullName: !fullName.trim(),
    };

    setError(newError);

    if (newError.phone || newError.email || newError.fullName) {
      return;
    }
    
    sendFirstStepData();
  };

  return (
    <div className='form_reg'>
      <h2 className="box_head mb_2">היכרות והרשמה</h2>
      <h6 className="box_head_h6">כמו בכל קשר חדש, קודם כל נלמד להכיר אותך טוב יותר כדי שנוכל לצאת לדרך חדשה ולתת לך את הכלים לקבל שליטה טובה יותר על המוצרים הפיננסים שלך.</h6>
      
      <p className='log_label'>שם מלא</p>
      <TextField
        type="text"
        size={window.innerWidth < 767 ? 'small' : "medium"}
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        error={error.fullName}
        helperText={error.fullName ? "נא להזין שם מלא." : ""}
        InputProps={{
          sx: { borderRadius: window.innerWidth > 767 ? 3 : 1 },
        }}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#1b7870',
            },
          },
          '& .MuiFormHelperText-root': {
            color: '#fc4747 !important',
            textAlign: 'right',
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder="הזן את שמך המלא"
        variant="outlined"
        autoComplete="name" // Explicitly set autocomplete for full name
      />

      <p className='log_label'>כתובת דוא"ל</p>
      <TextField
        type="email"
        size={window.innerWidth < 767 ? 'small' : "medium"}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={error.email}
        helperText={error.email ? "נא להזין כתובת אימייל חוקית." : ""}
        InputProps={{
          sx: { borderRadius: window.innerWidth > 767 ? 3 : 1 },
        }}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#1b7870',
            },
          },
          '& .MuiFormHelperText-root': {
            color: '#fc4747 !important',
            textAlign: 'right',
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder='הזן את כתובת הדוא"ל שלך'
        variant="outlined"
        autoComplete="email" // Explicitly set autocomplete for email
      />

      <p className='log_label'>מספר טלפון</p>
      <TextField
        type='tel'
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        error={error.phone}
        helperText={error.phone ? "נא להזין מספר טלפון חוקי." : ""}
        size={window.innerWidth < 767 ? 'small' : "medium"}
        InputProps={{
          // startAdornment: (
          //   <InputAdornment style={{ color: 'black', fontWeight: 500 }} position="start">
          //     <span className='pre-num'>972+</span>
          //   </InputAdornment>
          // ),
        }}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            borderRadius: window.innerWidth < 767 ? "5px" : "10px",
            '&:hover fieldset': {
              borderColor: '#1b7870',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1b7870',
            },
            '&.Mui-error fieldset': {
              borderColor: '#fc4747',
            },
          },
          '& .MuiFormHelperText-root': {
            color: '#fc4747 !important',
            textAlign: 'right',
            fontWeight: 500,
            marginRight: "0px",
          },
        }}
        id="outlined-basic"
        placeholder="הזן את מספר הטלפון שלך"
        variant="outlined"
        autoComplete="tel" // Explicitly set autocomplete for phone
      />

      <button className='login_btn' onClick={validateForm}>
        שלחו לי קוד כניסה בSMS
      </button>
      
      { errorText && <p className="error_text">מידע לא חוקי או משוכפל. אנא בדוק ונסה שוב.</p>}
      {/* <p className='divison'>אוֹ</p> */}
      {/* <div className='wa_div'>
        <img className='wa_icon' src={whatsappIcon} alt='whatsapp' />
        <p className='wa_text'>שלחו לי קוד כניסה בווואטסאפ</p>
      </div> */}
      <div className='text-center' onClick={()=> navigate('/login')}>
        <span className='link_btn'>
          כבר נרשמת? לחץ כאן להתחברות 
        </span>
      </div>
    </div>
  );
};

export default Register;
